module.exports = __webpack_public_path__ + "img/historia20.31a210bb.jpg";